import React, { useEffect, useState, useRef } from "react";
import { Table } from "antd";
import { Row } from "react-bootstrap";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import { useDispatch } from "react-redux";
import { fetchWorkoutPlanThunk } from "../../redux/Slices/workoutPlanSlice";
import CommonWorkoutPlan from "./CommonWorkoutPlan";

const options = { month: "short", timeZone: "UTC" };

const formatDate = (isoDateStr) => {
  const [datePart] = isoDateStr.split("T");
  const [year, month, day] = datePart.split("-").map(Number);
  const dummyDate = new Date(Date.UTC(2000, month - 1, 1));
  const monthStr = new Intl.DateTimeFormat("en-US", options)
    .format(dummyDate)
    .toUpperCase();

  return `${day} ${monthStr}`;
};
const prepareTableData = (groupedData) => {
  const options = { month: "short" };

  return groupedData?.map((group, index) => {
    const workoutDates = group.map((item) => item.workoutDate.split("T")[0]);

    const sortedDates = workoutDates.sort();
    const minDateStr = sortedDates[0];
    const maxDateStr = sortedDates[sortedDates.length - 1];

    const formatDate = (isoDateStr) => {
      const [year, month, day] = isoDateStr?.split("-");
      const date = new Date(isoDateStr); // safe because it's midnight UTC
      return `${parseInt(day)} ${date
        .toLocaleString("en-US", options)
        .toUpperCase()}`;
    };

    const maxYear = new Date(maxDateStr).getFullYear();

    const dateRangeText =
      minDateStr === maxDateStr
        ? `${formatDate(minDateStr)} ${maxYear}`
        : `${formatDate(minDateStr)} - ${formatDate(maxDateStr)} ${maxYear}`;

    return {
      key: index,
      dateRange: (
        <div className="workout-History-DateRange">{dateRangeText}</div>
      ),
      items: group,
    };
  });
};

function WorkoutListItemTable({ group, coachId }) {
  const dispatch = useDispatch();
  const { trans } = useCustomTranslation();
  const tableRef = useRef(null);
  const headerRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [total, setTotal] = useState(0);

  const emojiMap = {
    "face-frown": trans("ClientWorkout.faceFrownIcon"),
    "face-meh": trans("ClientWorkout.faceMehIcon"),
    "face-smile": trans("ClientWorkout.faceSmileIcon"),
    "face-grin": trans("ClientWorkout.faceGrinIcon"),
    "face-grin-hearts": trans("ClientWorkout.faceGrinHeartsIcon"),
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const tableData = prepareTableData(group);

  useEffect(() => {
    setTotal(group.length);
  }, [group]);

  const columns = [
    {
      title: "",
      dataIndex: "dateRange",
      key: "dateRange",
    },
  ];

  const expandableSession = (record) => {
    return (
      <div>
        <CommonWorkoutPlan workoutPlan={record} isHistory={true} />
      </div>
    );
  };

  const expandedRowRender = (record) => {
    const options = { month: "short" };
    const formatProgress = (percent) => {
      if (percent === 100) {
        return <div className="workout-plan-progress-bar">{percent}%</div>;
      }
      return <div className="workout-plan-progress-bar">{percent}%</div>;
    };
    const columns = [
      {
        title: "",
        dataIndex: "workoutSession",
        width: "20%",
        key: "workoutSession",
        render: (text, record) => (
          <div>
            <span className="font-size-one-two">{record.sesionName}</span>
            <br />
            <div className="workout-plan">
              {" "}
              {formatDate(record.workoutDate)}
            </div>
          </div>
        ),
      },
      // {
      //   title: "",
      //   dataIndex: "completion",
      //   width: "27%",
      //   key: "completion",
      //   render: (completion) => (
      //     <div className="client-workout-completion-progress-bar">
      //       <Progress
      //         format={formatProgress}
      //         strokeColor={{
      //           "0%": "#383D8D",
      //           "100%": "#A42066",
      //         }}
      //         percent={completion}
      //         className="workout-plan client-progress-width"
      //       />
      //     </div>
      //   ),
      // },
      {
        title: "",
        dataIndex: "enjoyment",
        width: "20%",
        key: "enjoyment",
        render: (value) => (
          <span className="workout-plan font-size-one-one">
            {emojiMap[value] || ""}
          </span>
        ),
      },
      {
        title: "",
        dataIndex: "exertion",
        width: "23%",
        key: "exertion",
        render: (value) => (
          <span className="workout-plan font-size-one-one">
            {value === trans("ClientWorkout.hard") ? "🔥 " : "🔥 "}
            {value}
          </span>
        ),
      },
      {
        title: "",
        dataIndex: "workoutDate",
        width: "30%",
        key: "workoutDate",
        render: (value) => (
          <span className="workout-plan font-size-one-one">
            {/* {new Date(value).getDate() +
              " " +
              new Date(value).toLocaleString("en-US", options).toUpperCase()} */}
            {formatDate(value)}
          </span>
        ),
      },
    ];
    return (
      <Table
        expandable={{
          expandedRowRender: expandableSession,
          expandIcon: expandIconSessions,
        }}
        columns={columns}
        dataSource={record.items}
        showHeader={false}
        pagination={false}
        rowKey="date"
      />
    );
  };

  const getShowingText = () => {
    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, total);
    return `Showing ${start} to ${end} of ${total} results`;
  };

  const expandIcon = ({ expanded, onExpand, record }) => {
    return (
      <div
        className="client-expand-icon"
        onClick={(e) => {
          e.stopPropagation();
          onExpand(record, e);
        }}
      >
        <div>
          {expanded ? (
            <i className="bi bi-caret-up-fill"></i>
          ) : (
            <i className="bi bi-caret-right-fill"></i>
          )}
        </div>
      </div>
    );
  };

  const handleArrowClick = (record, e, clientId, planId) => {
    dispatch(
      fetchWorkoutPlanThunk({
        clientId: clientId,
        coachId: coachId,
        coachWorkoutPlanId: record?.clientWorkoutPlanId,
      })
    );
    e.stopPropagation();
  };

  const expandIconSessions = ({ expanded, onExpand, record }) => {
    return (
      <div
        className="client-expand-icon"
        onClick={(e) => {
          e.stopPropagation();
          handleArrowClick(record, e);
          onExpand(record, e);
        }}
      >
        <div>
          {expanded ? (
            <i className="bi bi-caret-up-fill"></i>
          ) : (
            <i className="bi bi-caret-right-fill"></i>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="workout-list-item-table-with-row">
      <Row
        className="background-merge-workout-history client-table-heading-highlight"
        ref={headerRef}
      >
        <div className="heading-workout-history">
          <div className="completion-workout"></div>
          <div className="header-enjoyment">
            {trans("ClientWorkout.enjoyment")}
          </div>
          <div className="header-excertion">
            {trans("ClientWorkout.excertion")}
          </div>
          <div className="header-date">{trans("ClientWorkout.date")}</div>
        </div>
      </Row>

      <Table
        scroll={{ y: 300 }}
        columns={columns}
        showHeader={false}
        expandable={{ expandedRowRender, expandIcon }}
        dataSource={tableData}
        rowHoverable={false}
        rowKey="key"
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: total,
          onChange: handlePageChange,
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "25", "50"],
          onShowSizeChange: (size) => {
            setPageSize(size);
          },
          showTotal: () => <p className="workout-plan">{getShowingText()}</p>,
        }}
        locale={{
          emptyText: "No workout history available",
        }}
        ref={tableRef}
      />
    </div>
  );
}

export default WorkoutListItemTable;
